import React, { useState } from "react";
import api from "../api/axios";

const AddNews = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    isHome: false,
    status_Info: 1,
    app_Web: "",
    remark: "",
    newsImgS: null,
    newsImgB: null
  });

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "file") {
      setFormData({ ...formData, [name]: files[0] });
    } else if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");

    const data = new FormData();
    data.append("Name", formData.name);
    data.append("Description", formData.description);
    data.append("IsHome", formData.isHome ? 1 : 0);
    data.append("Status_Info", formData.status_Info);
    data.append("App_Web", formData.app_Web);
    data.append("Remark", formData.remark);

    if (formData.newsImgS) data.append("NewsImgS", formData.newsImgS);
    if (formData.newsImgB) data.append("NewsImgB", formData.newsImgB);

    try {
      const res = await api.post("/Master/AddNews", data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
console.log("API Response:", res.data);

      setSuccessMsg("News submitted successfully!");

      // Reset form
      setFormData({
        name: "",
        description: "",
        isHome: false,
        status_Info: 1,
        app_Web: "",
        remark: "",
        newsImgS: null,
        newsImgB: null
      });
    } catch (err) {
      console.error(err);
      setErrorMsg("Error uploading news. Please try again.");
    }
  };

  return (
<div className="card shadow">
      <div className="card-header bg-primary text-white">
        <h4>Add News</h4>
      </div>

      <div className="card-body">
      <form onSubmit={handleSubmit} encType="multipart/form-data">
      

      {successMsg && <div style={{ color: "green" }}>{successMsg}</div>}
      {errorMsg && <div style={{ color: "red" }}>{errorMsg}</div>}
        <div className="row">

<div className="col-md-12 mb-3">
      <input
        type="text"
        name="name"
        placeholder="News Title"
        value={formData.name}
        onChange={handleChange}
        className="form-control"
        required
      /></div>
<div className="col-md-12 mb-3">
      <textarea
        name="description"
        placeholder="Description"
        value={formData.description}
        onChange={handleChange}
        className="form-control"
      ></textarea></div>


<div className="col-md-4 mb-3">
      <input
        type="file"
        name="newsImgS"
        accept="image/*"
        onChange={handleChange}
        className="form-control"
      /></div>
<div className="col-md-4 mb-3">
      <input
        type="file"
        name="newsImgB"
        accept="image/*"
        onChange={handleChange}
        className="form-control"
      /></div>


{/* <div className="col-md-12 mb-3">
   <textarea
        name="remark"
        placeholder="Remarks"
        value={formData.remark}
        onChange={handleChange}
        className="form-control"
      ></textarea> */}

      {/* <input
        type="text"
        name="remark"
        placeholder="Remark"
        value={formData.remark}
        onChange={handleChange}
        className="form-control"
      /> */}
      {/* </div> */}
      <div className="col-md-12 mb-3  mt-3 text-center">
      <label>
        <input
          type="checkbox"
          name="isHome"
          checked={formData.isHome}
          onChange={handleChange}
        />
        Show on Home
      </label></div>
   {/* <label>
        <input
          type="checkbox"
          name="app_Web"
          checked={formData.app_Web}
          onChange={handleChange}
        />
        Show on App
      </label> */}
      {/* <div className="col-md-12 mb-3 text-center"><input
        type="text"
        name="app_Web"
        placeholder="App/Web"
        value={formData.app_Web}
        onChange={handleChange}
        className="form-control"
      /> 
      </div> */}
<div className="col-md-12 mb-3 text-center"><button type="submit" className="btn btn-primary">Submit</button></div>
      </div>
    </form>
        </div>
        </div>
    
  );
};

export default AddNews;
